import {API_BASE_URL, clippingAuditUrl} from '../../constants/apiRoutes';

export const loadStatistics = (typeParam) => {
    return fetch(`${API_BASE_URL}${clippingAuditUrl.BASE_URL}${clippingAuditUrl.STATISTICS}?type=${typeParam}`, {headers: {'Content-type': 'application/json'}})
    .then(catchResponse)
    .then(makeResult)
    .catch(logError)
}

const catchResponse = (response) => (response.ok)? response.json() : Promise.reject(response)
const makeResult = (response) => (response['result'])
const logError = error => error.json().then((json) => console.log(json))